import { render, staticRenderFns } from "./OcorrenciasVal.vue?vue&type=template&id=2d7b6938&"
import script from "./OcorrenciasVal.vue?vue&type=script&lang=js&"
export * from "./OcorrenciasVal.vue?vue&type=script&lang=js&"
import style0 from "./OcorrenciasVal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports